
  import { Vue, Component, Prop } from "vue-property-decorator";

  import UIButton from "@/components/button/ui-button.vue";
  import PaymentCardForm from "@/components/payment/PaymentCardForm.vue";
  import FormError from "@/components/common/FormError.vue";

  import lambdaRequest from "@/helpers/lambdaRequest";

  import PaymentCardDataChangeEventPayload from "@/entities/PaymentCardDataChangeEventPayload";
  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";

  @Component({
    components: {
      UIButton,
      PaymentCardForm,
      FormError,
    },
  })
  export default class EditPaymentCardForm extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, required: true }) readonly cardId!: string;

    card: stripe.elements.Element | null = null;
    cardDataValid: boolean = false;
    processing: boolean = false;
    errorMessage: string = "";

    onPaymentCardDataChange(payload: PaymentCardDataChangeEventPayload): void {
      const { complete, card } = payload;
      this.card = card;
      this.cardDataValid = complete;
    }

    async editCard(): Promise<void> {
      if (!this.cardDataValid || this.processing || !this.card) {
        return;
      }

      this.processing = true;

      try {
        const { token, error } = await this.$stripe.createToken(this.card);

        if (error) {
          throw error;
        }

        await lambdaRequest({
          lambdaName: "editPaymentCard",
          requestData: {
            token: token!.id,
            card_id: this.cardId,
            user_id: this.currentUserId,
          },
          method: "put",
        });

        this.$emit("cardEdited", { cardId: token!.card!.id });
        this.$eventBus.emit(NOTIFICATION, Message.successMessage("The credit card has been updated"));
      } catch (error) {
        const { message } = error;

        this.errorMessage = message;
      } finally {
        this.processing = false;
      }
    }

    get isErrorShown(): boolean {
      return this.errorMessage.length > 0;
    }
  }
